import React from "react"

function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer>
      <div>
        <p>
          {" "}
          Made with <span role="img"></span>🖤. ⓒ Copyright {year}
        </p>
      </div>
    </footer>
  )
}

export default Footer
